var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationContact(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 39,
    viewBox: "0 0 38 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0003 18.7084C17.9505 18.7084 16.9437 18.2914 16.2014 17.549C15.459 16.8067 15.042 15.7999 15.042 14.7501C15.042 13.7003 15.459 12.6934 16.2014 11.9511C16.9437 11.2088 17.9505 10.7917 19.0003 10.7917C20.0501 10.7917 21.057 11.2088 21.7993 11.9511C22.5416 12.6934 22.9587 13.7003 22.9587 14.7501C22.9587 15.2699 22.8563 15.7846 22.6573 16.2649C22.4584 16.7451 22.1669 17.1815 21.7993 17.549C21.4317 17.9166 20.9954 18.2082 20.5151 18.4071C20.0349 18.606 19.5201 18.7084 19.0003 18.7084ZM19.0003 3.66675C16.0608 3.66675 13.2418 4.83445 11.1632 6.91298C9.0847 8.99151 7.91699 11.8106 7.91699 14.7501C7.91699 23.0626 19.0003 35.3334 19.0003 35.3334C19.0003 35.3334 30.0837 23.0626 30.0837 14.7501C30.0837 11.8106 28.916 8.99151 26.8374 6.91298C24.7589 4.83445 21.9398 3.66675 19.0003 3.66675Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationContact);
export default __webpack_public_path__ + "static/media/location-contact.d999589ce012104fd28ee1f283b72d71.svg";
export { ForwardRef as ReactComponent };